import {Kontekst} from "felles/tjenester/Kontekst";
import {kopierFraAjsTilNg2} from "../../modell/ajsNg2ModellBroer";
import {Autentisering} from "felles/tjenester/Autentisering";
import {BrukerkontekstTilbyder} from "../BrukerkontekstTilbyder";
import {Inject, Injectable} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Brukerkontekst} from "felles-ng2/tjenester/Brukerkontekst";
import {ajs_$rootScope_DI_TOKEN, AjsRootScopeService} from "web-ng2/tjenester/ajs/AjsRootScopeService";
import {Språkvalg} from "felles/tjenester/i18n/Spraakvalg";
import {TidssonevelgerKontroller} from "web/komponenter/tidssonevelger/tidssonevelger";
import {BrukerkontekstAdministrasjon} from "felles-ng2/tjenester/BrukerkontekstAdministrasjon";

const debug = initDebugger('AjsKontekstBro');

/** Tjeneste som sørger for å eksponere informasjon om innlogget bruker satt i ajs {@link Kontekst}
 * via ng2-ekvivalenten {@link BrukerkontekstTilbyder} */
@Injectable({providedIn: 'root'})
export class AjsKontekstBro {

    constructor(private kontekstAdministrasjon: BrukerkontekstAdministrasjon,
                private ajsKontekst: Kontekst,
                private ajsSpråkvalg: Språkvalg,
                @Inject(ajs_$rootScope_DI_TOKEN) private $rootScope: AjsRootScopeService) {
    }

    /** setter autentisert bruker fra bruker satt på ajs-kontekst.
     * Lytter til eventer fra ajs for å oppdatere bruker satt i konteksttilbyder.
     * MERK at vi ikke de-registrerer lytterne vi reg på $rootScope da AjsKontekstBro er et singleton. */
    hentAutentisertBrukerFraAjs() {
        //AutentisertOkModell må migreres til ng2 bla pga AutentisertOkModell.tilgjengeligeGrupper.aktiveMedlemmer.roller.periode (bruker temporal-apiet)
        if (this.ajsKontekst.erAutentisert()) this.setFraAjsKontekst();

        //initieres i ajs Autentisering når bruker har blitt autentisert mot server etter at ajs Kontekst har blitt oppdatert
        this.$rootScope.$on(Autentisering.brukerAutentisertEvent, () => this.setFraAjsKontekst());

        //initieres i ajs Kontekst når Kontekst.relastBrukerOgGrupper() / kontekst.relastBruker() kalles etter at ajs Kontekst har blitt oppdatert med nye verdier
        this.$rootScope.$on(Kontekst.brukerRelastetEvent, () => this.setFraAjsKontekst());

        //oppdater kontekst når brukers språk endres via ajs Språkvalg
        this.ajsSpråkvalg.språk$().subscribe(() => this.setFraAjsKontekst());

        //oppdater kontekst når brukers tidssone endres via ajs TidssonevelgerKontroller
        this.$rootScope.$on(TidssonevelgerKontroller.tidssonevalgtEvent, () => this.setFraAjsKontekst());

        this.ajsSpråkvalg.språk$().subscribe(språk => this.setFraAjsKontekst());

        //initieres i ajs Autentisering.lokalLoggUt() når bruker logges ut
        this.$rootScope.$on(Autentisering.brukerLoggetUtEvent, () => this.kontekstAdministrasjon.setBrukerLoggetUt());
    }

    //private hjelpemetoder

    private setFraAjsKontekst() {
        debug(`setFraAjsKontekst: autentisert: ${this.ajsKontekst.erAutentisert()}, setter autentisert: ${this.ajsKontekst.autentisert()?.bruker?.brukernavn}`, this.ajsKontekst.autentisert())
        if (!this.ajsKontekst.erAutentisert()) return;
        this.kontekstAdministrasjon.setAutentisertBruker(new Brukerkontekst(kopierFraAjsTilNg2(this.ajsKontekst.autentisert())));
    }
}
